import React from 'react';
import './Patterns.css';

export type SyncPillTone = 'ok' | 'offline' | 'queued';

export interface SyncPillProps {
  tone: SyncPillTone;
  label: string; // e.g. "Online", "Offline", "Syncing 2…"
  testId?: string;
}

export const SyncPill: React.FC<SyncPillProps> = ({ tone, label, testId }) => {
  const iconClass =
    tone === 'ok'      ? 'bi-wifi'
  : tone === 'offline' ? 'bi-wifi-off'
  :                      'bi-cloud-arrow-up';
  return (
    <span
      data-testid={testId ?? 'sync-pill'}
      className={`pat-sync-pill pat-sync-pill--${tone}`}
      aria-live="polite"
    >
      <i className={`bi ${iconClass}`} aria-hidden="true" />
      {label}
    </span>
  );
};
